export default "__VITE_ASSET__Bvkj974m__"